export const selectCourses = (state) => state.courses.courses
export const selectNoCoursesFound = (state) => state.courses.noCoursesFound



// WEBPACK FOOTER //
// ./src/services/courses/selectors.js